import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const DraftItemPlaceHolder = () => {
  const items = Array.from({ length: 5 }, (_, index) => index)

  return items.map(index => (
    <Styles.Container key={index}>
      <Styles.Header>
        <Skeleton variant="rounded" width="60px" height="60px" />
        <Styles.TextLines>
          <Skeleton variant="text" width="100%" height="24px" />
          <Skeleton variant="text" width="100%" height="16px" />
        </Styles.TextLines>
      </Styles.Header>
      <Styles.Content>
        <Styles.CodeBlocks>
          <Skeleton variant="rounded" width="304px" height="120px" />
          <Skeleton variant="rounded" width="304px" height="120px" />
        </Styles.CodeBlocks>
      </Styles.Content>
    </Styles.Container>
  ))
}

export default DraftItemPlaceHolder
